/** Laravel API base — no trailing slash. */
const PRODUCTION_API = "https://api.simcollect.com";
const LOCAL_API = "http://127.0.0.1:8000";

function isBrowserLocalHost() {
  if (typeof window === "undefined") return false;
  const host = window.location.hostname;
  return host === "localhost" || host === "127.0.0.1";
}

function isLocalApiUrl(url) {
  return !url || /^(https?:\/\/)?(localhost|127\.0\.0\.1)(:\d+)?\/?$/i.test(url);
}

function resolveApiBaseUrl() {
  const envUrl = process.env.REACT_APP_API_BASE_URL?.replace(/\/$/, "");

  if (typeof window !== "undefined") {
    if (isBrowserLocalHost()) {
      return isLocalApiUrl(envUrl) ? envUrl || LOCAL_API : envUrl;
    }
    // Live/staging hosts must never call 127.0.0.1, even if the build env was wrong.
    return isLocalApiUrl(envUrl) ? PRODUCTION_API : envUrl || PRODUCTION_API;
  }

  return envUrl || (process.env.NODE_ENV === "development" ? LOCAL_API : PRODUCTION_API);
}

export const API_BASE_URL = resolveApiBaseUrl();

/** When true, login/profile use local mock instead of the API. */
export const USE_MOCK_AUTH = process.env.REACT_APP_USE_MOCK_AUTH === "true";

export const PROVS_AUTH = {
  request: "/api/provs/auth/request",
  verify: "/api/provs/auth/verify",
  /** Shared OTP resend endpoint (as provided by backend). */
  resend: "/api/ops/auth/resend-otp",
  logout: "/api/provs/logout",
};

export const PROVIDER_API = {
  profile: "/api/provs/profile",
  live: "/api/provs/live",
  portfolioGroups: "/api/provs/portfolio-groups",
  portfolioUpload: "/api/provs/portfolios/upload",
  portfolioFileUploads: "/api/provs/portfolios/file-uploads",
  debtCustomers: "/api/provs/debt-customers",
  debtCustomersSummary: "/api/provs/debt-customers/summary",
  cases: "/api/provs/cases",
  casesSummary: "/api/provs/cases/summary",
  payments: "/api/provs/payments",
  paymentsSummary: "/api/provs/payments/summary",
  callLogs: "/api/provs/call-logs",
  callLogsSummary: "/api/provs/call-logs/summary",
  escalations: "/api/provs/escalations",
  portfolioGroupsSummary: "/api/provs/portfolio-groups/summary",
  dashboardOverview: "/api/provs/dashboard/overview",
  dashboardReport: "/api/provs/dashboard/report",
  dashboardCharts: "/api/provs/dashboard/charts",
  dashboardPriorityCases: "/api/provs/dashboard/priority-cases",
  activityLogs: "/api/provs/activity-logs",
  activityLogsFilters: "/api/provs/activity-logs/filters",
  activityLogsSummary: "/api/provs/activity-logs/summary",
  activityLogsSla: "/api/provs/activity-logs/sla",
  reports: "/api/provs/reports",
};

export function providerReportPath(slug) {
  return `${PROVIDER_API.reports}/${encodeURIComponent(slug)}`;
}

export function debtCustomerCasesPath(debtCustomerSlug) {
  return `${PROVIDER_API.debtCustomers}/${encodeURIComponent(debtCustomerSlug)}/cases`;
}

export function caseSlaPath(caseId) {
  return `${PROVIDER_API.cases}/${encodeURIComponent(caseId)}/sla`;
}

export function portfolioUploadRecordsPath(groupSlug, uploadId) {
  return `${PROVIDER_API.portfolioGroups}/${encodeURIComponent(groupSlug)}/uploads/${encodeURIComponent(uploadId)}/records`;
}

export function portfolioGroupRecordsPath(groupSlug) {
  return `${PROVIDER_API.portfolioGroups}/${encodeURIComponent(groupSlug)}/records`;
}

